import { ToggleButtonGroup, toggleButtonGroupClasses } from '@mui/material';
import { Route, Routes } from 'react-router-dom';
import { DVHLayoutToggle, ReviewStructuresToggle } from './LayoutToggles';

const viewerLayoutOptions = [DVHLayoutToggle, ReviewStructuresToggle];
const contourLayoutOptions = [ReviewStructuresToggle];
const doseLayoutOptions = [DVHLayoutToggle];

export default function LayoutOptions() {
    return (
        <ToggleButtonGroup
            color="primary"
            aria-label="text alignment"
            sx={(theme) => ({
                [`&.${toggleButtonGroupClasses.root}`]: {
                    columnGap: theme.spacing(1),
                    ':disabled': {
                        color: 'black',
                    },
                },
                [`& .${toggleButtonGroupClasses.middleButton}, 
                .${toggleButtonGroupClasses.lastButton}, 
                .${toggleButtonGroupClasses.firstButton}`]: {
                    borderRadius: `${theme.shape.borderRadius}px`,
                    borderLeft: `1px solid ${theme.palette.divider}`,
                },
            })}
        >
            <Routes>
                <Route
                    path="contour/*"
                    element={contourLayoutOptions.map((LayoutOption, index) => (
                        <LayoutOption key={index} />
                    ))}
                />
                <Route
                    path="dose/*"
                    element={doseLayoutOptions.map((LayoutOption, index) => (
                        <LayoutOption key={index} />
                    ))}
                />
                <Route
                    path="*"
                    element={viewerLayoutOptions.map((LayoutOption, index) => (
                        <LayoutOption key={index} />
                    ))}
                />
            </Routes>
        </ToggleButtonGroup>
    );
}
